interface IProps {
  title: string;
  header: string;
}

export const TitleHeader = ({ title, header }: IProps) => {
  return (
    <div className={`flex flex-col gap-2 lg:gap-4`}>
      <h1 className={"text-xl lg:text-5xl font-medium text-primary-600"}>
        {title}
      </h1>
      <h2 className={"text-md lg:text-3xl text-primary-400"}>{header}</h2>
    </div>
  );
};
